interface ToggleProps {
  toggleOn: boolean;
  handleToggleClick: () => void;
}

export default function ToggleBar({
  toggleOn,
  handleToggleClick,
}: ToggleProps) {
  return (
    <div className="relative">
      <button
        className={`border-2 border-primary rounded-full w-10 h-[22px] p-[2px] flex items-center justify-start focus:outline-none ${
          toggleOn ? "bg-primary" : "bg-white"
        }`}
        onClick={handleToggleClick}
      >
        <span
          className={`inline-block w-4 h-4 rounded-full transform transition-all duration-300 ease-in-out ${
            toggleOn ? "translate-x-full bg-white" : "translate-x-0 bg-primary"
          }`}
        />
      </button>
    </div>
  );
}
